import { useEffect, useState } from "react";
import { usePayByTextForm } from "./usePayByTextForm";
import { SliderPageWrapper } from "components/layout/sliderPageWrapper/SliderPageWrapper";
import { useTranslation } from "react-i18next";
import { useRootSelector, useRootDispatch } from "store";
import {
  getAccountRestrictions,
  getPaymentMethods,
  selectedAccountInfo,
} from "store/account/account-selector";
import { clearSlide } from "store/common/common-slice";
import { Dialog } from "components/common";
import { PayByTextContent } from "./PayByTextContent";

export const PayByTextMain: React.FC = () => {
  const clientConfig = useRootSelector((state) => state.config.client);
  const paymentMethodTypesEnabled = useRootSelector(getPaymentMethods);
  const accountInfo = useRootSelector(selectedAccountInfo);
  const { restrictions } = useRootSelector(getAccountRestrictions);
  const dispatch = useRootDispatch();

  const [showResultDialog, setShowResultDialog] = useState(false);
  const [saveResult, setSaveResult] = useState<"success" | "error" | null>(
    null,
  );
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const accountInformationId = accountInfo?.id;

  const {
    phoneNumber,
    paymentAmountTypeInput,
    paymentAmount,
    paymentMethodId,
    paymentMethodSelection,
    paymentMethods,
    isEnabled,
    save,
    initialize,
    meta,
    payByTextAccounts,
  } = usePayByTextForm(accountInformationId);

  const { t } = useTranslation([
    "common",
    "payment",
    "payment_next",
    "payment_final",
  ]);

  useEffect(() => {
    if (accountInformationId != null) {
      initialize();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountInformationId]);

  return (
    <SliderPageWrapper headerTitle={t("payment:paybytext_label")}>
      {meta.isLoading ? (
        <ft-screen-loader />
      ) : (
        <PayByTextContent
          phoneNumber={phoneNumber}
          paymentAmountTypeInput={paymentAmountTypeInput}
          paymentAmount={paymentAmount}
          paymentMethodId={paymentMethodId}
          paymentMethodSelection={paymentMethodSelection}
          payByTextAccounts={payByTextAccounts}
          isEnabled={isEnabled}
          save={save}
          setShowResultDialog={setShowResultDialog}
          setSaveResult={setSaveResult}
          setErrorMessage={setErrorMessage}
          accountInformationId={accountInformationId}
          clientConfig={clientConfig}
          paymentMethods={paymentMethods}
          paymentMethodTypesEnabled={paymentMethodTypesEnabled}
          restrictions={restrictions}
          dispatch={dispatch}
          t={t}
        />
      )}
      {showResultDialog && (
        <Dialog
          type={saveResult === "success" ? "default" : "error"}
          translatedMessage={
            saveResult === "success"
              ? t("payment_next:changes_saved_successfully")
              : errorMessage || t("common:something_went_wrong")
          }
          primaryActionLabel={t("common:okay_label")}
          dialogClosed={() => {
            setShowResultDialog(false);
            setErrorMessage(null);
            if (saveResult === "success") {
              dispatch(clearSlide());
            }
            setSaveResult(null);
          }}
          autoClose={true}
        />
      )}
    </SliderPageWrapper>
  );
};
